const chatConfig = {
    elementId: "chat-element",
    elementStyle: "width: 100%; height: calc(100vh - 6.5rem); height: calc(100svh - 6.5rem); border: none; background-color: transparent ",

    messageStyles: {
        default: {
            shared: {
                bubble: {
                    maxWidth: '100%', backgroundColor: 'unset', marginTop: '10px', marginBottom: '10px',
                    color: '#fafafa',
                },
                outerContainer: {
                    padding: '0.5rem 1rem',
                    borderRadius: '0.5rem',
                    fontSize: '16px',
                },
                innerContainer: {
                    width: '100%',
                }
            },
            user: {
                bubble: {
                    marginLeft: '0px',
                },
                outerContainer: {
                    backgroundColor: 'rgba(38, 39, 48, 0.7)'
                }
            },
            ai: {
                outerContainer: {
                    backgroundColor: 'transparent',
                }
            },
            woosmap: {
                bubble: {
                    display: 'flex',
                    width: '100%',
                    height: '400px'
                },
            }
        },
        loading: {
            message: {
                styles: {
                    bubble: {
                        "margin-top": "15px",
                        "backgroundColor": "rgba(38, 39, 48, 0.7)",
                        "fontSize": "18px",
                        "color": "white"
                    }
                }
            }
        },
    },
    textInput: {
        styles: {
            container: {
                borderRadius: '0.5rem',
                border: 'unset',
                width: 'calc(100% - 55px)',
                backgroundColor: 'rgb(38, 39, 48)',
                boxShadow: "0px 0.3px 0.9px rgba(0, 0, 0, 0.12), 0px 1.6px 3.6px rgba(0, 0, 0, 0.16)",
            },
            text: {
                padding: '12px', paddingLeft: '15px', paddingRight: '34px',
                color: '#fafafa',
            },
            input: {
                outline: 'rgb(255, 75, 75)'
            }
        },
        placeholder: {text: 'Welcome!', style: {color: "#BCBCBC"}}

    },
    submitButtonStyles: {
        submit: {
            "container": {
                "default": {
                    "bottom": "1em",
                    "right": "0.6em",
                    "borderRadius": "20px",
                    "width": "1.9em",
                    "height": "1.9em"
                }
            },
            svg: {
                styles: {
                    "default": {
                        filter: "brightness(0) saturate(100%) invert(100%)"
                    }
                },
            }
        },
        position: "inside-right"
    },
    auxiliaryStyle: `
    ::-webkit-scrollbar {
      background: transparent;
      border-radius: 100px;
      height: 6px;
      width: 6px;
    } 
    ::-webkit-scrollbar-track {
      background-color: transparent
    }`,
    introMessage: {
        text: "Hello! I’m your AI assistant here to help you find nearby Starbucks locations. Just share an address, city, zip code, or point of interest, and I’ll show the closest stores on a map and provide directions if needed. What location would you like to search?"
    },
    frenchIntroMessage: {
        text: "Bonjour! Je suis votre assistant IA, prêt à vous aider à trouver les Starbucks les plus proches. Il vous suffit de me donner une adresse, une ville, un code postal ou un point d’intérêt, et je vous afficherai les magasins les plus proches sur une carte, avec les directions si besoin. Quel endroit souhaitez-vous rechercher?"
    },
    useWoosmapAPIUrl: "https://evwzeuiwz5.execute-api.us-east-1.amazonaws.com/dev/use-woosmap/",
    //useWoosmapWSSUrl: "wss://y2ba5gdvxd.execute-api.us-east-1.amazonaws.com/dev",
    useWoosmapWSSUrl: "wss://y8cbmhf502.execute-api.us-east-1.amazonaws.com/dev",
    remarkable: {"html": true, "typographer": true},
    speechToText: {
        webSpeech: {"language": "en-US"},
        button: {
            active: {
                svg: {
                    styles: {
                        "default": {
                            bottom: "0.35em",
                            left: "0.35em",
                            filter: 'brightness(0) saturate(100%) invert(10%) sepia(97%) saturate(7495%) hue-rotate(0deg) brightness(101%) contrast(107%)'
                        },
                    },
                }
            },
            default: {
                "container": {
                    "default": {
                        "bottom": "1em",
                        "right": "0.6em",
                        "borderRadius": "20px",
                        "width": "1.9em",
                        "height": "1.9em"
                    }
                },
                svg: {
                    styles: {
                        "default": {
                            bottom: "0.35em",
                            left: "0.35em",
                            filter: "brightness(0) saturate(100%) invert(100%)"
                        },
                    },
                }
            },
            "position": "outside-right"
        }
    }
};

export default chatConfig;